/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/upgrade_raid': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M11.854 9.146l-.707.707 9.5 9.5c.979.978 1.6 2.514 1.531 2.77-.306.113-1.847-.499-2.824-1.477l-9.5-9.5-.707.707 9.5 9.5c.756.754 2.355 1.774 3.44 1.774.308 0 .573-.082.767-.274.877-.877-.531-3.238-1.5-4.207l-9.5-9.5zM13.354 21.646a.5.5 0 00-.707.707l2 2a.502.502 0 00.707.001.5.5 0 000-.707l-2-2.001zM18.646 9.354a.502.502 0 00.708 0 .5.5 0 000-.707l-2-2a.5.5 0 00-.707.707l1.999 2z"/><path pid="1" d="M28 19.354L31.354 16 28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646zM30.646 16L28 18.646v-5.293L30.646 16zM16 1.354L18.646 4h-5.293L16 1.354zM1.354 16L4 13.354v5.292L1.354 16zM16 30.646L13.354 28h5.292L16 30.646zM26 26H6V6h20v20z"/>'
  }
})
